/** Installation axis, not a ledger `Capability` - granted to the `admin` role only. */
export const IDENTITY_MANAGE_AUTHORITY = 'taler:identity:manage'

export function canManageIdentity(authorities: readonly string[]): boolean {
  return authorities.includes(IDENTITY_MANAGE_AUTHORITY)
}
